import React, { Component } from 'react'
import { Modal, DatePicker, Button, Alert } from 'antd'
import moment from 'moment'

const DATE_FORMAT = 'YYYY-MM-DD HH:mm:ss'

class StoDateMismatchModal extends Component<any, any> {
    state = { date: null, submitting: false, error: null }

    componentDidUpdate(prev) {
        if (!prev.visible && this.props.visible) {
            const createDate =
                this.props.mismatch && this.props.mismatch.sto_dates && this.props.mismatch.sto_dates.create_date
            this.setState({ date: createDate ? moment(createDate) : null, submitting: false, error: null })
        }
    }

    handleOk = async () => {
        const { date } = this.state
        if (!date) {
            this.setState({ error: 'יש לבחור תאריך' })
            return
        }
        this.setState({ submitting: true, error: null })
        try {
            const ok = await this.props.onSubmit(date.format(DATE_FORMAT))
            if (!ok) this.setState({ submitting: false, error: 'העדכון נכשל' })
        } catch (e) {
            this.setState({ submitting: false, error: 'העדכון נכשל' })
        }
    }

    render() {
        const { visible, onClose } = this.props
        const { date, submitting, error } = this.state
        return (
            <Modal
                visible={visible}
                title="תיקון תאריך הו״ק"
                onCancel={onClose}
                maskClosable={!submitting}
                footer={[
                    <Button key="cancel" onClick={onClose} disabled={submitting}>
                        ביטול
                    </Button>,
                    <Button key="ok" type="primary" loading={submitting} onClick={this.handleOk}>
                        שלח
                    </Button>
                ]}
            >
                <div style={{ direction: 'rtl', textAlign: 'right' }}>
                    <DatePicker
                        value={date}
                        showTime
                        format={DATE_FORMAT}
                        onChange={d => this.setState({ date: d })}
                        style={{ width: '100%', border: 'none' }}
                        disabled={submitting}
                    />
                    {error && <Alert style={{ marginTop: 12 }} type="error" message={error} />}
                </div>
            </Modal>
        )
    }
}

export default StoDateMismatchModal
